import React from 'react';
import { useOverlayContext } from 'seagull';
import { MapServicesModal } from "./MapServicesModal";
export const useOpenMapServicesModal = (serviceTemplateIds, reload) => {
  const overlayContext = useOverlayContext();
  return async function openMapServicesModal() {
    if (!serviceTemplateIds.length) {
      overlayContext.showErrorToast('An error occurred. ', 'no-services-to-map-toast');
      return;
    }
    await overlayContext.showModal({
      closeOnClickOutside: false,
      closeOnEscapeKey: false,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/React.createElement(MapServicesModal, {
          dismissModal: dismissModal,
          serviceTemplateIds: serviceTemplateIds,
          onChange: reload
        });
      }
    });
  };
};